import { createFileRoute } from "@tanstack/react-router"
import { setPasswordSchema } from "@/lib/schemas/set-password.schema"

export const Route = createFileRoute("/_auth/set-password")({
  validateSearch: input => setPasswordSchema.parse(input),
})
